<p-autoComplete [(ngModel)]="selectedCategories" [suggestions]="filteredCategories"
                (completeMethod)="filterCategory($event)"
                placeholder="Select categories..."
                field="label" [dropdown]="true" [multiple]="multiple" (onSelect)="onSelectedCategory($event)"
                (onUnselect)="onUnselectedCategory($event)"
                [style]="{width: '234px','min-height': '45px'}">
    <ng-template let-category pTemplate="item">
        <div>{{category.label}}</div>
    </ng-template>
</p-autoComplete>
